import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { showModal, setActiveWidget } from '../../redux/actions';
import { ClipLoader } from 'react-spinners';
import IdentityDocumentIcon from './IdentityDocumentIcon';

const TriggerContainer = styled.section`
  margin: 20px;
  background: #ffffff;
  padding: 25px;
  font-family: Roboto;
  border: 2px solid #e1e8ee;
  box-sizing: border-box;
  border-radius: 5px;
  font-size: 18px;
  display: flex;
`;

const IdentityDocumentTrigger = ({
  aciData,
  aciError,
  showModal,
  setActiveWidget,
  theme,
}) => {
  const hasAciData = Boolean(aciData?.passengers);
  const isCheckInWindowPassed = aciError?.type === 'ACI_CHECK_IN_WINDOW_PASSED';
  const hasError = Boolean(aciError);

  const buttonStyles = {
    width: '200px',
    height: '50px',
    color: '#ffffff',
    background: '#2990e6',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    cursor: 'pointer',
    ...(theme?.trigger ?? {}),
    ...(theme?.identityDocumentTrigger ?? {}),
  };

  const getDescriptionMessage = () => {
    if (isCheckInWindowPassed) {
      return (
        <FormattedMessage
          id="identity_document.check_in_window_passed.description"
          defaultMessage="Unable to update your identity document information. The check-in window for your flight has passed."
        />
      );
    }
    if (hasError) {
      return (
        <FormattedMessage
          id="identity_document.load_failed"
          defaultMessage="Trip does not exist or does not have an automatic check-in product."
        />
      );
    }
    if (hasAciData) {
      return (
        <FormattedMessage
          id="identity_document.load_success"
          defaultMessage="Please provide identity document information needed for check-in"
        />
      );
    }
    return (
      <FormattedMessage
        id="identity_document.load_failed"
        defaultMessage="Trip does not exist or does not have an automatic check-in product."
      />
    );
  };

  return (
    <TriggerContainer
      className="gr-block sm:gr-flex"
      data-testid="identity-document-trigger"
    >
      <div className="gr-flex-1">
        <div className="gr-flex">
          <IdentityDocumentIcon
            scale={2}
            data-testid="identity-document-widget-trigger-icon"
          />
          <div>
            <h2
              className="gr-m-0 gr-ml-4 gr-text-primary"
              data-testid="identity-document-widget-trigger-title"
            >
              <FormattedMessage
                id="identity_document.title"
                defaultMessage="Enter your travel documents"
              />
            </h2>
            <p
              className="gr-mx-4 gr-text-gray-600"
              data-testid="identity-document-widget-trigger-description"
            >
              {getDescriptionMessage()}
            </p>
          </div>
        </div>
      </div>
      <div className="gr-flex-1 gr-flex gr-items-center sm:gr-justify-end gr-justify-center gr-w-full sm:gr-w-full gr-overflow-auto">
        {!hasError &&
          (hasAciData ? (
            <button
              onClick={() => {
                showModal(true);
                setActiveWidget('automatic_check_in');
              }}
              id="gordian-identity-document-selection"
              className="gr-text-center gr-border-0 gr-rounded-lg"
              style={buttonStyles}
              data-testid="identity-document-widget-trigger-add-button"
            >
              <FormattedMessage
                id="identity_document.add_documents"
                defaultMessage="Add documents"
              />
            </button>
          ) : (
            <button
              disabled
              id="gordian-identity-document-selection"
              className="gr-text-center gr-border-0 gr-rounded-lg"
              style={buttonStyles}
              data-testid="identity-document-widget-trigger-add-button"
            >
              <ClipLoader
                size={25}
                color={'white'}
                data-testid="identity-document-widget-trigger-loader"
              />
            </button>
          ))}
      </div>
    </TriggerContainer>
  );
};

const mapStateToProps = (state) => ({
  aciData: state.aci.data,
  aciError: state.aci.error,
  theme: state.session.theme,
});

const mapDispatchToProps = {
  showModal,
  setActiveWidget,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdentityDocumentTrigger);
